const config = require('../../json/couponplatz.config.json');
const STORAGE_KEY = config.storageKey;
const store = require("store");
const util = require('../util/util');

var Cart = function () {
	var self = this;
	self.items = store.get(STORAGE_KEY) || [];
	self.getCart = () => {
		return self.items;
	};
	self.getCartBase64 = () => {
		return util.btoa(JSON.stringify(self.items));
	};
	self.store = () => {
		store.set(STORAGE_KEY, self.items);
	};
	self.unstore = () => {
		store.remove(STORAGE_KEY);
	};
	self.updateCartStorage = () => {
		self.items.length ? self.store() : self.unstore();
	};
	self.totalCount = () => {
		return self.items.reduce( (result, currentValue) => {
			return result + currentValue.count;
		}, 0);
	};
	self.cardCount = (card) => {
		let cartItem = self.items.find(item => item.couponcode === card.couponcode);
		return cartItem ? cartItem.count : 0;
	};
	self.totalSavingsValue = () => {
		return self.items.reduce( (result, currentValue) => {
			return (result + (currentValue.count * currentValue.facevalue/100));
		}, 0);
	};
	self.add = (card) => {
		let cartItem = self.items.find(item => item.couponcode === card.couponcode);
		if (!cartItem) {
			cartItem = {
				count: 0,
				couponcode: card.couponcode,
				facevalue: card.facevalue,
				name: card.title,
			};
			self.items.push(cartItem);
		}
		cartItem.count++;
		self.updateCartStorage();
	},
	self.remove = (cartItem) => {
		self.items.splice(self.items.findIndex( item => item === cartItem ), 1);
		self.updateCartStorage();
	};
	self.clear = () => {
		self.items.splice(0);
		self.unstore();
	};
	self.print = () => {
		console.log(util.btoa(JSON.stringify(self.items)));
		console.log(btoa(JSON.stringify(self.items)));
	};
};

module.exports = Cart;



// WEBPACK FOOTER //
// ./src/assets/js/domain/Cart.js